'use client'

import { useParams } from 'next/navigation'
import { useMemo } from 'react'

export default function Breadcrumb() {
  const { mainCategory, category, subCategory, content } = useParams<{
    mainCategory?: string
    category?: string
    subCategory?: string
    content?: string
  }>()

  const crumbs: Array<{
    href: string
    label: string
  }> = useMemo(() => {
    const crumbs = [
      {
        href: '/',
        label: 'Home',
      },
    ]

    if (mainCategory) {
      crumbs.push({
        href: `/${mainCategory}`,
        label: mainCategory,
      })

      if (category) {
        crumbs.push({
          href: `/${mainCategory}/${category}`,
          label: category,
        })

        if (subCategory) {
          crumbs.push({
            href: `/${mainCategory}/${category}/${subCategory}`,
            label: subCategory,
          })

          if (content) {
            crumbs.push({
              href: `/${mainCategory}/${category}/${subCategory}/${content}`,
              label: content,
            })
          }
        }
      }
    }

    return crumbs
  }, [category, content, mainCategory, subCategory])

  return (
    <nav className="breadcrumbs tw-text-sm tw-font-medium" aria-label="Breadcrumb">
      <ol className="tw-flex tw-items-center tw-space-x-4">
        {crumbs.map((crumb, index) => (
          <li key={index}>
            <div className="tw-flex tw-items-center">
              {index !== 0 && '>'}
              <a href={crumb.href} className="tw-ml-4 tw-text-gray-500 hover:tw-text-gray-700">
                {crumb.label}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  )
}
